import { useQuery } from '@tanstack/react-query'
import { TUserItem } from 'shared/types'
import { api } from '..'

export const getUser = (userId: string) =>
  api.get<TUserItem>(`/v1/users/${userId}`).then(({ data }) => data)

export const useGetUser = (userId?: string) => {
  if (!userId) throw new Error('Missing userId')
  return useQuery({
    queryFn: () => getUser(userId),
    queryKey: ['users', userId],
  })
}
